import apiClient from "../../utils/clients/axios";

export const createLap = async (payload) => {
  const response = await apiClient.post(`api/quality_control/lap`, payload);

  return response;
};
